import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { ToastRef } from '@aid/toast/services';
import {
  toastAnimations,
  ToastAnimationState
} from '@aid/toast/animations/toast.animation';
import { AnimationEvent } from '@angular/animations';
import {
  TOAST_CONFIGURATION,
  TOAST_TEMPLATE,
  ToastConfig,
  ToastTemplate
} from '@aid/toast/utils/toast-config';

@Component({
  selector: 'aid-toast',
  template: `
    <div
      class="toast border-radius-8"
      matRipple
      [@fadeAnimation]="{
        value: animationState,
        params: {
          fadeIn: toastConfig.animation.fadeIn,
          fadeOut: toastConfig.animation.fadeOut
        }
      }"
      (@fadeAnimation.done)="onFadeFinished($event)"
    >
      <ng-template #container></ng-template>
    </div>
  `,
  styleUrls: ['./toast.component.scss'],
  animations: [toastAnimations.fadeToast],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToastComponent implements OnInit, OnDestroy {
  animationState: ToastAnimationState = 'default';

  private intervalId?: ReturnType<typeof setTimeout>;

  @ViewChild('container', { read: ViewContainerRef, static: true })
  entry?: ViewContainerRef;

  private readonly ref = inject(ToastRef);
  private readonly toastTemplate = inject<ToastTemplate>(TOAST_TEMPLATE);
  readonly toastConfig = inject<ToastConfig>(TOAST_CONFIGURATION);

  ngOnInit() {
    const component = this.toastTemplate.template;
    if (!this.entry) {
      throw new Error('The toast container is not rendered.');
    }
    this.entry.clear();
    this.entry.createComponent(component);

    this.intervalId = setTimeout(() => (this.animationState = 'closing'), 5000);
  }

  onClose() {
    this.ref.close();
  }

  onFadeFinished(event: AnimationEvent) {
    const { toState } = event;
    const isFadeOut = (toState as ToastAnimationState) === 'closing';
    const isFinished = this.animationState === 'closing';

    if (isFadeOut && isFinished) {
      this.onClose();
    }
  }
  ngOnDestroy() {
    clearTimeout(this.intervalId);
  }
}
